import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB3-U3-P29-E1',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page29/E1/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page29/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page29/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/3.jpg', input: true, answer: "their" },
        { url: 'img/FriendsPlus/Page29/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page29/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page29/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/7.jpg', input: true, answer: "our" },
        { url: 'img/FriendsPlus/Page29/E1/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page29/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page29/E1/10.jpg', input: true, answer: "their" },
        { url: 'img/FriendsPlus/Page29/E1/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page29/E1/12.jpg' },
      ],

    ]
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB3-U3-P29-E1',
    audio: 'img/FriendsPlus/Page29/Audio/audio-e2-p29.mp3',
    video: '',
    component: D1,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page29/E2/Key/answerKey.png',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page29/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page29/E2/2.jpg', audioUrl: "img/FriendsPlus/Page29/Audio/tieude-e2-p29.mp3" },
        { url: 'img/FriendsPlus/Page29/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page29/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page29/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page29/E2/6.jpg', input: true, answer: "art" },
        { url: 'img/FriendsPlus/Page29/E2/7.jpg' },
        { url: 'img/FriendsPlus/Page29/E2/8.jpg', input: true, answer: "music" },
        { url: 'img/FriendsPlus/Page29/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page29/E2/10.jpg', input: true, answer: "P.E." },
        { url: 'img/FriendsPlus/Page29/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page29/E2/12.jpg', input: true, answer: "English" },
        { url: 'img/FriendsPlus/Page29/E2/13.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page29/E2/14.jpg' },
      ],


    ]
  },




}

export default json;